import { useMixpanel } from '@shared/lib/mixpanel/hooks';
import { useCallback, useEffect } from 'react';
import { PlatformType, getPlatform } from '../../../shared/lib/mixpanel/platformType';
import useFeatureIsAccessible from '../useFeatureIsAccessible';

const flow = 'Authentication';

type FlowData = {
  source?: 'email' | 'invitation_link' | 'project_link' | 'direct';
  method?: 'email' | 'facebook' | 'google' | 'phone' | 'diia';
  action?: 'sign_in' | 'register';
  skip_phone?: boolean;
  // platform type
  platform?: PlatformType;
};

export const useUpdateAuthenticationFlow = () => {
  const { updateFlow } = useMixpanel<typeof flow, FlowData>();

  return useCallback((data: FlowData) => updateFlow(flow, data), [updateFlow]);
};

export const useRegisterAuthenticationFlow = (data: FlowData) => {
  const { registerFlow } = useMixpanel<typeof flow, FlowData>();
  const isLite = useFeatureIsAccessible('isLite');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => registerFlow(flow, { platform: getPlatform(isLite), ...data }), []);
};
